import React from 'react'
import { useTranslation } from 'next-i18next'
import { MePayout } from '../../../../../../types/Payout/MePayout'
import PayoutMethodDisplay from './PayoutMethodDisplay'
import PayoutTransactionDetailsTab from './PayoutTransactionDetailsTab'
import DisplayPayoutRevenues from '../../../../../shared/DisplayPayoutRevenues'

interface PayoutsReviewTabDetailsProps {
  mePayout: MePayout
}

export default function PayoutsReviewTabDetails({
  mePayout,
}: PayoutsReviewTabDetailsProps) {
  const { t } = useTranslation('dashboard')

  return (
    <div className="mt-3">
      <div className="border-y py-3">
        <PayoutMethodDisplay userPayoutMethod={mePayout.userPayoutMethod} />
      </div>

      <div className="my-3 overflow-hidden rounded-md bg-slate-100">
        <PayoutTransactionDetailsTab
          payoutTransactionDetails={
            mePayout.payoutDistributionTransactionDetails
          }
        />
      </div>

      <div className="mt-3">
        <div className="border-gray-10 border-b border-dashed pb-3">
          <div className="flex space-x-1">
            <p className="text-gray-700">
              {t('payoutsReview.tabDetails.transactionDetails.grossTotal')}
            </p>
            <p className="text-gray-800">
              {mePayout.netAmount && (
                <DisplayPayoutRevenues
                  revenues={mePayout.amount}
                  currency={mePayout.userPayoutMethod.payoutMethod.currency}
                  digitAfterDecimalPoint={2}
                  decimals={2}
                />
              )}
            </p>
          </div>
          <div className="flex space-x-1">
            <p className="text-gray-700">
              {t('payoutsReview.tabDetails.transactionDetails.feesTotal')}
            </p>
            <p className="text-gray-800">
              <DisplayPayoutRevenues
                revenues={mePayout.totalFees ?? 0}
                currency={mePayout.userPayoutMethod.payoutMethod.currency}
                digitAfterDecimalPoint={2}
                decimals={2}
              />
            </p>
          </div>
        </div>

        <div className="pt-3">
          <div className="flex items-end space-x-1">
            <p className="text-gray-700">
              {t('payoutsReview.tabDetails.transactionDetails.netTotal')}
            </p>
            <p className="text-xl font-medium text-green-600">
              {mePayout.netAmount && (
                <DisplayPayoutRevenues
                  revenues={mePayout.netAmount}
                  currency={mePayout.userPayoutMethod.payoutMethod.currency}
                  digitAfterDecimalPoint={2}
                  decimals={2}
                />
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
